import { Helmet } from "react-helmet-async";
import NavbarTop from "../../components/NavbarTop";
import { useEffect, useRef, useState, useCallback } from "react";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import PostList from "../../components/Post/PostList";
import { useAuth, useMessage } from "../../global-components/src";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css"
import ModalPostLikes from "../Posts/PostLikes/ModalPostLikes";
// import ModalPostComments from "../Posts/PostLikes/ModalPostComments";
import { getViewedAds, updateViewedAds } from "../../utils/ads";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import ModalCommentsBottom from "../../components/Modals/comments/comments-bottom";
import { PostLoading } from "../../components/Post/post-loading";
import ModalComments from "../../components/Modals/comments/modal-comments";
import { LeftContent, RightContent, SponsoredContent } from "../../global-components/src/components/screen/left-content";
import { t } from "../../global-components/src/i18nTranslate";
import ReelsFeed from "../Flow/reels-feed";
import { Film, FileText } from "lucide-react";
import { useTranslation } from 'react-i18next';

const Saveds: React.FC = () => {
    const [posts, setPosts] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(1);
    const [cursor, setCursor] = useState<number | null>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [feedType, setFeedType] = useState("feed");
    const [savedType, setSavedType] = useState<"posts" | "reels">("posts");
    const [error, setError] = useState("");
    const { user, token, isAuthenticated } = useAuth();
    const userImg = user?.img_account ? BUCKET_PACOCA_URL + "/" + user?.img_account.replace(/\.\.\//g, '') : "/img/img-account.png";
    const hasRun = useRef(false);
    const [idPostSelected, setIdPOstSelected] = useState<number | null>(null)
    const [show, setShow] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const { setMessage } = useMessage();
    const { t } = useTranslation();

    const loadPosts = async (cursorParam: number | null = cursor) => {
        const viewedAds = getViewedAds();
        const viewedAdsParam = viewedAds.join(',');
        let url = `${PACOCA_API_URL}/posts?feedType=${feedType}&viewed_ads=${viewedAdsParam}&saveds=true`;

        if(cursorParam){
            url += `&cursor=${cursorParam}`;
        }

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.posts;
            setCursor(response.data.next_cursor);

            if (data.length > 0) {
                setPosts((prev) => {
                    const existingIds = new Set(prev.map(post => post?.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.filter((post: { id: any; }) => !existingIds.has(post?.id)); // Filtra apenas posts novos
                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
                    const updatedPosts = [...prev, ...newPosts];
                    updateViewedAds(data);
                    return updatedPosts;
                });
            } else {
                setEnd(true);
            }
            
        } catch (err: any) {
            console.error("Failed to load posts:", err);
            setEnd(true);
            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "warning")
        } finally {
            setLoading(false);
        }
    };

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting && !loading && !end) {
                setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        if (!hasRun.current || page != 1) {
            loadPosts(cursor);
            // Salva a página atual no localStorage
            sessionStorage.setItem('page', page.toString());
            hasRun.current = true;

        }
    }, [page, feedType]);

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    useEffect(() => {
        // Salva a posição de rolagem quando o feed for modificado
        const handleScroll = () => {
            sessionStorage.setItem("scrollPosition", window.scrollY.toString());
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleModalClose = () => {
            setShow(false)
            setShowModalComments(false)
            setIdPOstSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    return (
        <div className="container container-feed" style={{ paddingTop: "60px", minWidth: "100%!important", minHeight: "100dvh" }}>
            <Helmet>
                <title>Paçoca</title>
                <meta name="description" content={`Posts do Paçoca com a hashtag ${t("post.saveds")}`}/>
                <meta name="keywords" content={`${t("post.saveds")}, ${t("post.saveds")} Paçoca, rede social, fazer amigos, conexões online, comunidade digital, rede social brasileira, criar perfil online, compartilhar momentos`}/>
                <meta name="author" content="Paçoca Inc."/>
                <meta property="og:title" content={`Posts do Paçoca com a hashtag ${t("post.saveds")}`}/>
                <meta property="og:description" content={`Posts do Paçoca com a hashtag ${t("post.saveds")}`}/>
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type" content="website"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={`Posts do Paçoca com a hashtag ${t("post.saveds")}`}/>
                <meta name="twitter:description" content={`Posts do Paçoca com a hashtag ${t("post.saveds")}`}/>
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
            </Helmet>
            
            <LeftContent/>
            <RightContent>
                <SponsoredContent/>
            </RightContent>

            <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-4" style={{position: "relative"}}>
                    <NavbarTop title={t("post.saveds")} />

                    <div className="saved-content-tabs" role="tablist" aria-label="Conteúdo salvo">
                        <button className={savedType === "posts" ? "active" : ""} onClick={() => setSavedType("posts")} role="tab" aria-selected={savedType === "posts"}>
                            <FileText size={16} /> Posts
                        </button>
                        <button className={savedType === "reels" ? "active" : ""} onClick={() => setSavedType("reels")} role="tab" aria-selected={savedType === "reels"}>
                            <Film size={16} /> Reels
                        </button>
                    </div>

                    {savedType === "reels" ? (
                        <ReelsFeed savedOnly />
                    ) : <div className="postlist-hashtag">
                        <PostList onOpenComments={(idPost) => {setShowModalComments(true); setIdPOstSelected(idPost);}} onOpenLikes={(idPost) => {setShow(true); setIdPOstSelected(idPost)}} posts={posts} setPosts={setPosts}/>

                        <div ref={endOfListRef} style={{ height: "20px" }}></div>

                        <PostLoading loading={loading}/>

                        {end && Boolean(posts.length) && (
                            <div style={{ textAlign: "center", marginTop: "20px", display: "flex", justifyContent: "center" }}>
                                <div id="text-carregar" style={{ textAlign: "center", marginTop: "20px" }}>
                                    Fim dos posts
                                </div>
                            </div>
                        )}

                        {end && Boolean(!posts.length) && (
                            <span className="span-empty mt-5" style={{ width: "100%" }}>
                               <svg style={{ opacity: 0.5, height: 100, width: 100, marginBottom: 30 }} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="icon-fillter bi bi-postcard-heart icone-conta" viewBox="0 0 16 16">
                                    <path d="M8 4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" />
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z" />
                                </svg>
                                <h3 className="w-100 text-center">Nenhum post encontrado</h3>
                            </span>
                        )}
                    </div>}
                </div>
            </div>
            <ModalPostLikes idPostSelected={idPostSelected} show={show} />
            {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected}/> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}
        </div>
    );
};

export default Saveds;
